type PostsType = 'all' | 'author' | 'category' | 'species';

interface BlogMetadata {
  metadataTitle: string;
  metadataDescription: string;
}

export const getBlogMetaData = (type: PostsType, page: number, title?: string): BlogMetadata => {
  const pagePrefix = page > 1 ? `Page ${page} - ` : '';
  const defaultTitle = `${pagePrefix}Fishbrain blog ➡️ Latest news, tips, events & more`;
  const defaultTitleSuffix = ' | Fishbrain blog';

  const defaultDescriptionsuffix =
    '🐟 Become a better angler with Fishbrain ✅ Download the Fishing app & Join our community today';
  const defaultDescription = `${pagePrefix}Discover the latest fishing content from Fishbrain Blog ${defaultDescriptionsuffix}`;
  const categoryDescriptionSuffix = ` ➡️ Fishbrain brings the latest news, announcements and changes in the US and world fishing sector ${defaultDescriptionsuffix}`;

  switch (type) {
    case 'all':
      return { metadataTitle: defaultTitle, metadataDescription: defaultDescription };
    case 'author':
      return {
        metadataTitle: `${pagePrefix}Fishbrain blog ➡️ Check out posts by ${title}`,
        metadataDescription: `${pagePrefix}Discover the latest fishing content from ${title} ${defaultDescriptionsuffix}`,
      };

    case 'species':
      return {
        metadataTitle: `${pagePrefix}Fishbrain blog ➡️ Check out posts about ${title}`,
        metadataDescription: `${pagePrefix}Discover the latest fishing content about ${title} ${defaultDescriptionsuffix}`,
      };
    case 'category':
      switch (title) {
        case 'Fishing News':
          return {
            metadataTitle: `${pagePrefix}Latest Fishing news, announcements & stories${defaultTitleSuffix}`,
            metadataDescription: `${pagePrefix}Fishing news${categoryDescriptionSuffix}`,
          };
        case 'General':
          return {
            metadataTitle: `${pagePrefix}Latest fishing community news and stories${defaultTitleSuffix}`,
            metadataDescription: `${pagePrefix}Community news${categoryDescriptionSuffix}`,
          };
        case 'Fishbrain':
          return {
            metadataTitle: `${pagePrefix}Fishbrain news, announcements & product information${defaultTitleSuffix}`,
            metadataDescription: `${pagePrefix}Fishbrain news${categoryDescriptionSuffix}`,
          };

        case 'Fishing Tips':
          return {
            metadataTitle: `${pagePrefix}Best fishing guides, styles, tips and tutorials${defaultTitleSuffix}`,
            metadataDescription: `${pagePrefix}Fishing tips${categoryDescriptionSuffix}`,
          };
        case 'Fishing Gear':
          return {
            metadataTitle: `${pagePrefix}Expert opinions and guides on fishing gear${defaultTitleSuffix}`,
            metadataDescription: `${pagePrefix}Fishing gear guides${categoryDescriptionSuffix}`,
          };

        default:
          return {
            metadataTitle: `${pagePrefix}Fishbrain blog ➡️ Check out ${title} posts`,
            metadataDescription: defaultDescription,
          };
      }
    default:
      return { metadataTitle: defaultTitle, metadataDescription: defaultDescription };
  }
};
